import React from "react";
import {Route, Routes} from "react-router-dom";
import {WebGLMaskDrawPage} from "../pages/webgl-mask-draw";

export const WebGLMaskDrawRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<WebGLMaskDrawPage />} />
        </Routes>
    );
};
